import karteCustonEventClient from '../common/karte/custom_event';

document.addEventListener('DOMContentLoaded', () => {
  const newDiv = document.getElementById('notification_images_new');
  if (newDiv == null) {
    return;
  }

  const titleInput = document.querySelector('#notification-images-title') as HTMLInputElement;
  if (titleInput != null) {
      titleInput.addEventListener('keyup', () => {
            const titleLength = titleInput.value.length;
            const titleLengthSpan = document.querySelector('#title-text-length');
            if (titleLengthSpan != null) {
                    titleLengthSpan.textContent = String(titleLength);
                    const classList = titleLengthSpan.classList;
                    if (titleLength > 26) {
                              if (!classList.contains('text-danger')) {
                                          classList.add('text-danger');
                                        }
              } else {
                        if (classList.contains('text-danger')) {
                                    classList.remove('text-danger');
                                  }
              }
            }
          });
  }

  const bodyInput = document.querySelector('#notification-images-body') as HTMLTextAreaElement;
  if (bodyInput != null) {
      bodyInput.addEventListener('keyup', () => {
            const bodyLength = bodyInput.value.length;
            const bodyLengthSpan = document.querySelector('#body-text-length');
            if (bodyLengthSpan != null) {
                    bodyLengthSpan.textContent = String(bodyLength);
                    const classList = bodyLengthSpan.classList;
                    if (bodyLength > 95) {
                              if (!classList.contains('text-danger')) {
                                          classList.add('text-danger');
                                        }
              } else {
                        if (classList.contains('text-danger')) {
                                    classList.remove('text-danger');
                                  }
              }
            }
          });
  }

  newDiv.addEventListener('submit', () => {
    // KARTEに登録イベントを送信
    sendKarteEvent(
      'create_content',
      'notification_images',
      'お知らせ画像を作成しました'
    );
  })


  const sendKarteEvent = (event_name: string, content_name: string, message: string) => {
    // 投稿したことをKARTEに通知
    karteCustonEventClient.sendEvent({
      event_name: event_name,
      content_name: content_name,
      message: message
    });
  }
})
